import { render, staticRenderFns } from "./BankItem.vue?vue&type=template&id=e53320c0&scoped=true&"
import script from "./BankItem.vue?vue&type=script&lang=js&"
export * from "./BankItem.vue?vue&type=script&lang=js&"
import style0 from "./BankItem.vue?vue&type=style&index=0&id=e53320c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53320c0",
  null
  
)

export default component.exports